export default __webpack_public_path__ + "static/media/more-icon-bar.e8db7520.svg";